export default {
    agldtTreebankUrl: 'https://perseusdl.github.io/treebank_data/',
    backendApiCorporaPath: 'corpora',
    backendApiExerciseListPath: 'exerciseList',
    backendApiExercisePath: 'exercise',
    backendApiFilePath: 'file',
    backendApiFrequencyPath: 'frequency',
    backendApiH5pPath: 'h5p',
    backendApiKwicPath: 'kwic',
    backendApiRawtextPath: 'rawtext',
    backendApiValidReffPath: 'validReff',
    backendApiVectorNetworkPath: 'vectorNetwork',
    backendApiVocabularyPath: 'vocabulary',
    backendApiZenodoPath: 'zenodo',
    backendBaseApiPath: '/mc-service/mc/api/v1.0',
    backendBaseUrl: '',
    bambergCoreVocabularyUrl: 'https://www.ccbuchner.de/reihe-0-0/adeo-53/',
    callidusProjectUrl: 'https://www.projekte.hu-berlin.de/de/callidus',
    developerMailTo: 'mailto:schulzkx@hu-berlin.de?subject=[CALLIDUS-Software]',
    frontendBaseUrl: '',
    intervalCorporaUpdate: 1209600000,
    localStorageKeyApplicationState: 'mc/applicationState',
    localStorageKeyCorpora: 'mc/corpora',
    localStorageKeyH5P: 'mc/h5p',
    localStorageKeyUpdateInfo: 'mc/updateInfo_v2',
    machinaCallidaConceptUrl: 'https://www.projekte.hu-berlin.de/de/callidus/machina-callida',
    machinaCallidaSourceCodeUrl: 'https://scm.cms.hu-berlin.de/callidus/machina-callida',
    maxTextLength: 0,
    menuId: 'mc-menu',
    pageUrlAuthor: '/author',
    pageUrlAuthorDetail: '/author-detail',
    pageUrlConfirmCancel: '/confirm-cancel',
    pageUrlDocExercises: '/doc-exercises',
    pageUrlDocSoftware: '/doc-software',
    pageUrlDocVocUnit: '/doc-voc-unit',
    pageUrlEmbed: '/embed',
    pageUrlExercise: '/exercise',
    pageUrlExerciseList: '/exercise-list',
    pageUrlExerciseParameters: '/exercise-parameters',
    pageUrlHome: '/home',
    pageUrlImprint: '/imprint',
    pageUrlInfo: '/info',
    pageUrlKwic: '/kwic',
    pageUrlPreview: '/preview',
    pageUrlRanking: '/ranking',
    pageUrlSequences: '/sequences',
    pageUrlShowText: '/show-text',
    pageUrlSemantics: '/semantics',
    pageUrlSources: '/sources',
    pageUrlTest: '/test',
    pageUrlTextRange: '/text-range',
    pageUrlUploadText: '/upload-text',
    pageUrlTutorial: '/tutorial',
    pageUrlVocabularyCheck: '/vocabulary-check',
    perseidsCTSapiBaseUrl: 'https://cts.perseids.org/api/cts?request=',
    perseidsCTSapiGetCapabilities: 'GetCapabilities',
    perseidsCTSapiGetValidReff: 'GetValidReff',
    perseidsCTSapiUrnSnippet: '&urn=',
    proielProjectUrl: 'https://proiel.github.io/',
    vivaURN: 'urn:custom:latinLit:viva.lat',
    xAPIverbIDanswered: 'http://adlnet.gov/expapi/verbs/answered',
};
